<template>
  <div class="div_main">
    <div class="card-div div_left">
      <br />
      <h1 class="ml-3">Camera Inside</h1>
      <img
        v-if="img_camera.inside && img_camera.inside !== ''"
        class="mb-5"
        :src="`data:image/jpeg;base64,${img_camera.inside}`"
        style="width: 100%; height: 400px"
        alt="Camera Inside"
      />
      <img
        v-else
        class="mb-5"
        src="https://via.placeholder.com/500x400/f1f1f1/000.png?text=Not+found+camera+image"
        style="width: 100%; height: 400px"
        alt="Camera Inside"
      />
    </div>
    <div class="card-div div_right">
      <br />
      <h1 class="ml-3">Camera Outside</h1>
      <img
        v-if="img_camera.outside && img_camera.outside !== ''"
        class="mb-5"
        :src="`data:image/jpeg;base64,${img_camera.outside}`"
        style="width: 100%; height: 400px"
        alt="Camera Outside"
      />
      <img
        v-else
        class="mb-5"
        src="https://via.placeholder.com/500x400/f1f1f1/000.png?text=Not+found+camera+image"
        style="width: 100%; height: 400px"
        alt="Camera Outside"
      />
    </div>
  </div>
</template>

<script>
export default {
  props: ["img_camera"],
};
</script>

<style scoped>
.card-div {
  background: white;
  border-radius: 30px;
  -webkit-box-shadow: 0 4px 25px 0 rgb(0 0 0 / 10%);
  box-shadow: 0 4px 25px 0 rgb(0 0 0 / 10%);
  -webkit-transition: all 0.3s ease;
  transition: all 0.3s ease;
}
.div_main {
  width: 100%;
  display: flex;
}
.div_left {
  width: 50%;
  height: 500px;
  margin-right: 30px;
}
.div_right {
  width: 50%;
  height: 500px;
  margin-left: 30px;
}
@media screen and (max-width: 700px) {
  .div_main {
    flex-wrap: wrap;
  }
  .div_left {
    width: 100%;
    margin: 0;
  }
  .div_right {
    width: 100%;
    margin-left: 0;
    margin-top: 15px;
  }
}
</style>